"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Hot Module Replacement
__export(require("./helpers"));
__export(require("./experimental"));
__export(require("./hmr"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angularclass/hmr/dist/index.js
// module id = ./node_modules/@angularclass/hmr/dist/index.js
// module chunks = vendor